import React from 'react';

import Modal from 'BookingFlow/components/Modal';

function NgmfFeeDisclaimerModal({ feeDisclaimerBookingMessages = [], closeModal }) {
	return (
		<Modal className="new-modal--ngmf-fee-disclaimer" closeModal={closeModal}>
			<div className="ngmf-fee-disclaimer-modal">
				{feeDisclaimerBookingMessages.map(({ title, body }, index) => (
					<section key={index} className="ngmf-fee-disclaimer-modal__message">
						{title && <h2 className="ngmf-fee-disclaimer-modal__title">{title}</h2>}
						{body && (
							<div
								className="ngmf-fee-disclaimer-modal__body"
								dangerouslySetInnerHTML={{ __html: body }}
							/>
						)}
					</section>
				))}
			</div>
		</Modal>
	);
}

export default NgmfFeeDisclaimerModal;
